import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { isMobileApp } from '../../../../common/common';
import { Share } from '@capacitor/share';

export default function ShareCard({ data, customClass, shareClick }) {
  const [shareData, setShareData] = useState({});
  const [extraCustomClass, setextraCustomClass] = useState('');

  useEffect(() => {
    let tempData = {};
    tempData = {
      title: data.title,
      // text: data.text,
      url: data.url
    };
    setShareData(tempData);

    if (customClass) {
      setextraCustomClass(customClass);
    }
  }, []);

  const share_url = async () => {
    if (isMobileApp()) {
      await Share.share(shareData);
    }
    else {
      if (navigator.canShare) {
        try {
          await navigator.share(shareData);
        } catch (error) {
          console.log(error);
        }
      } else {
        toast.info('Copied to clipboard');
        copy_to_Clipboard(shareData.url);
      }
    }
  };
  const copy_to_Clipboard = (str) => {
    let textarea;
    let result;
    try {
      textarea = document.createElement('textarea');
      textarea.setAttribute('readonly', true);
      textarea.setAttribute('contenteditable', true);
      textarea.style.position = 'fixed'; // prevent scroll from jumping to the bottom when focus is set.
      textarea.value = str;

      document.body.appendChild(textarea);

      textarea.focus();
      textarea.select();

      const range = document.createRange();
      range.selectNodeContents(textarea);

      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);

      textarea.setSelectionRange(0, textarea.value.length);
      result = document.execCommand('copy');
    } catch (err) {
      console.error(err);
      result = null;
    } finally {
      document.body.removeChild(textarea);
    }
    if (!result) {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
      result = prompt(`Press ${copyHotkey}`, str); // eslint-disable-line no-alert
      if (!result) {
        return false;
      }
    }

    return true;
  };
  return (
    <>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
        className={customClass}
        onClick={() => {
          share_url();
          if (shareClick && typeof shareClick == 'function') {
            shareClick();
          }
        }}
      >
        <path d="M5.5 15a3.51 3.51 0 0 0 2.36-.93l6.26 3.58a3.06 3.06 0 0 0-.12.85 3.53 3.53 0 1 0 1.14-2.57l-6.26-3.58a2.74 2.74 0 0 0 .12-.76l6.15-3.52A3.49 3.49 0 1 0 14 5.5a3.35 3.35 0 0 0 .12.85L8.43 9.6A3.5 3.5 0 1 0 5.5 15zm12 2a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm0-13A1.5 1.5 0 1 1 16 5.5 1.5 1.5 0 0 1 17.5 4zm-12 6A1.5 1.5 0 1 1 4 11.5 1.5 1.5 0 0 1 5.5 10z"></path>
      </svg>
    </>
  );
}
